import PATH from "constants/path";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isAuthenticated } from "utils/common";
import { getDetailPlace } from "features/Place/placeSlice";
import { ChevronRight } from "assets/svg";
import { useParams } from "react-router-dom";
import { SERVICE } from "constants/global";
import ErrorDB from "components/ErrorDB";

function PlaceDetail() {
  const dispatch = useDispatch();

  const { id } = useParams();
  const { place, isInLine } = useSelector((state) => state.place);

  useEffect(() => {
    if (id) {
      dispatch(getDetailPlace({ service: SERVICE, id }));
    }
  }, []);

  if (!place && !id && !isInLine) return null;

  return (
    <div
      className={
        isAuthenticated() ? "w-80" : "container px-0 px-md-3 px-lg-0"
      }
    >
      <div className="border-sticky border-news-no-top bg-f4 p-2 p-md-2 text-grey">
        <div className="position-relative text-center fs-14 fw-600">
          収録会場
          <a
            href={PATH.AREA_LIST}
            className="d-flex position-absolute start-0 top-0"
          >
            <i className="bi bi-chevron-left"></i>
            <span className="d-none d-md-block">戻る</span>
          </a>
        </div>
      </div>
      {
        isInLine ?
        <ErrorDB style={'mt-4'}/>
        :
        <>
          <div className="px-3 px-md-0">
            <div className="mt-2">
              <div className="text-start fw-600 fs-22 fs-sm-18">
                {place?.name}
              </div>
              <div className="fs-12">{place?.address}</div>
            </div>

            <div className="border-news-top my-2" />

            <div className="border-color-black border-form-hidden border-radius-5 my-1 p-0 p-md-4">
              <div className="d-flex flex-column flex-md-row justify-content-between">
                <div>
                  <div className="mt-4 pre-line" dangerouslySetInnerHTML={{ __html: place?.access }}></div>
                </div>
                <div
                  className="custom-iframe"
                  dangerouslySetInnerHTML={{
                    __html: place?.google_map_url,
                  }}
                ></div>
              </div>
            </div>
          </div>

          <div className="text-grey fw-600 mt-4">
            <div className="w-130 mx-auto text-end mt-2">
              <a href={PATH.AREA_LIST}>
                収録会場一覧
                <span className="ms-2">
                  <ChevronRight />
                </span>
              </a>
            </div>
            <div className="w-130 mx-auto text-end mt-2">
              <a href={PATH.TOP}>
                トップページ
                <span className="ms-2">
                  <ChevronRight />
                </span>
              </a>
            </div>
          </div>
        </>
      }
        
    </div>
  );
}

export default PlaceDetail;
